import React, { useEffect, useState } from 'react';

/**
 * NnormalArama: NNormal markasının arama talebinin dışarıdan röntgeni.
 * Route: /r/nnormal-arama (sidebar YOK, tam ekran slayt).
 *
 * 18 slayt, 16:9. Tasarım dili Gürgençler lansman sunumlarıyla ortak; o CSS
 * dosyaları canlıda duran başka sunumlara da hizmet ediyor, değiştirilmedi.
 * Yeniden üretmek için: node src/pages/nnormal-arama/build.js
 * Ölçümü tazelemek için: python3 src/pages/nnormal-arama/fetch.py (Keyword Planner)
 *
 * 🔑 "PDF olarak yazdır" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P
 *    slaytları tek sayfaya kırpar; düğmeyi dışarı taşıma.
 * 🔴 iframe'e sandbox EKLEME, yazdırma kırılır.
 *
 * HTML modülü ~90KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function NnormalArama() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./nnormalAramaHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="NNormal · Arama Talebi Röntgeni"
      srcDoc={html}
      style={fill}
    />
  );
}
